export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

export const TYPE_LOW = 'LOW';
export const TYPE_FULL = 'FULL';
export const DIRECTION_ASC = 'ASC';
export const DIRECTION_DESC = 'DESC';
export const INTEGER = 'INTEGER';
export const MAPPER_UP_AND_DOWN_ASC_DESC = {
  down: DIRECTION_DESC,
  up: DIRECTION_ASC,
};

export const SUPPORT_EMAIL = 'supportocer@enel.com';
